import React, { Component } from 'react';
import { Segment, Grid, Header, Button } from 'semantic-ui-react';
import _ from  'underscore';
import { Link } from 'react-router-dom';

class LatestHealthArticlesVideosWidget extends Component {
    render() {
        return (
            <div>
                <Header as='h4' attached='top' block>
                    Health Articles & Videos
                </Header>
                <Link to="/app/healtharticles">
                    <Button attached>
                        See All Articles & Videos
                    </Button>
                </Link>
                <Segment attached>
                    <Grid columns={1}>
                        {
                            _.map(this.props.articleBannerList, (article) => {
                                const {
                                    imageURL,
                                    title,
                                    uuid,
                                    url
                                } = article;
                                return (
                                    <Grid.Column key={uuid}>
                                        <div className="ui fluid image" alt="description" style={{backgroundColor: '#000'}}>
                                            <a href={url} target="blank" id={uuid}>
                                                <img src={imageURL} style={{opacity: 0.5}}/>
                                                <div style={{position: 'absolute', top: 0, width: '100%', height: 'auto', color: '#fff', padding: 20}}>
                                                    <h2>
                                                        {title}
                                                    </h2>
                                                </div>
                                            </a>
                                        </div>
                                    </Grid.Column>
                                );
                            })
                        }
                    </Grid>
                </Segment>
            </div>
        );
    }
}

export default LatestHealthArticlesVideosWidget;
